import { Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Event, NavigationEnd, Router, RouterEvent, RouterModule } from '@angular/router'
import { delay, elementAt, filter, map, mergeMap, mergeMapTo } from 'rxjs/operators'
import { SubSink } from 'subsink'

import { RfAuthenticationService } from './authentication/rf-authentication.service'
import { MobileComponent } from './shared/components/mobile/interface/mobile.component'
import { SNACKBAR_CLASS } from './shared/components/snackbar/model/snackbar.model'
import { SnackbarService } from './shared/components/snackbar/service/snackbar.service'
import { I18NStorageService } from './shared/i18n/service/i18n-storage-service'
import { I18nService } from './shared/i18n/service/i18n.service'
import { LoadingService } from './shared/service/loading/loading.service'
import { SharedService } from './shared/service/shared.service'
import { ProfileManagementService } from './shared/service/store-management/profile-management/profile-management.service'
import { UserService } from './shared/service/user/user.service'
import { environment } from 'src/environments/environment'
import { NotificationsService } from './shared/service/notifications/notifications.service'
import { ApiSearchUtilService } from './shared/service/api-search-util/api-search-util.service'
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { ProfileChooseService } from './shared/components/dialog/components/profile-choose/service/profile-choose.service'
import { DialogService } from './shared/components/dialog/service/dialog.service'
import { WelcomeComponent } from './feature/home/welcome/welcome.component'
import { Profile } from './shared/service/store-management/model/profile'
import { CsManagementService } from './shared/service/store-management/cs-management/cs-management.service'
import { StorageService } from './shared/service/storage/storage.service'
import { Observable } from 'rxjs'
import { SupportService } from './feature/support/service/support.service'
import { CommonModule } from '@angular/common'
import { I18nPipe } from './shared/i18n/pipe/i18n.pipe'
import { MaterialModule } from './shared/module/material.module'
import { SidenavComponent } from './shared/components/sidenav/sidenav.component'
import { HeaderComponent } from './core/header/header.component'
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component'
import { FooterComponent } from './core/footer/footer.component'

declare const setScreenName: Function
declare const window: any

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule,
		MaterialModule,
		RouterModule,
		SidenavComponent,
		HeaderComponent,
		BreadcrumbComponent,
		FooterComponent
	]
})
export class AppComponent extends MobileComponent implements OnInit, OnDestroy {
	title = 'my-ald'
	up
	isSidenavOpen = false
	sideNavItems: Array<any>
	sso
	isLoadUp = false
	loading = false
	basePath = window.location.hostname
	codiceCapoGruppoConsipExLP = [
		'41625139', '42024168', '487388', '841795', '41180061', '701052284', 
		'701299482', '701508959', '23683', '41625139', '700013364', '700113529', 
		'41789588', '700695419', '700870798', '701115232', '700803278', '42024168'
	]

	private subs = new SubSink()
	favIcon: HTMLLinkElement = document.querySelector('#appIcon')
	constructor(
		private i18nstorageService: I18NStorageService,
		private i18nService: I18nService,
		private sharedService: SharedService,
		private authService: RfAuthenticationService,
		// tslint:disable-next-line: variable-name
		private _loading: LoadingService,
		private userService: UserService,
		private profileManagementService: ProfileManagementService,
		private csManagementService: CsManagementService,
		private profileChooseService: ProfileChooseService,
		private snack: SnackbarService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService,
		private apiSearchUtilService: ApiSearchUtilService,
		private injector: Injector,
		private dialog: DialogService,
		private storageService: StorageService,
		private supportService: SupportService,
	) {
		super()
		this.favIcon.href = this.apiSearchUtilService.loadFavicon()
		this.i18nService.fetch('it').subscribe((dictionaryRetrieved) => {
			this.i18nstorageService.setDictionary(dictionaryRetrieved)
		})

		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				map(() => this.rootRoute(this.route)),
				filter((route: ActivatedRoute) => route.outlet === 'primary'),
				mergeMap((route: ActivatedRoute) => route.data)
			)
			.subscribe((event: { [name: string]: any }) => {
				if (environment.mobile && event['title']) {
					// Set screen name
					setScreenName(event['title'])
				}
				if (this.isLogged()) {
					// Register device (web and mobile)
					const token = localStorage.getItem('fcm_token')
					const sent = localStorage.getItem('fcm_token_sent')
					if (!sent && token) {
						this.subs.sink = this.notificationsService.registerDevice(token).subscribe((res) => {
							localStorage.setItem('fcm_token_sent', '1')
						})
					}
					// Set Data for Analytics web
					if (environment.env === 'uat' || environment.env === 'prod' ) {
						this.setGTMUserProfile()
					}
				}
			})
	}

	//TODO da verificare approccio per MATOMO
	setGTMUserProfile(): void {
		if (!environment.mobile) {
			const profile = this.profileManagementService.getProfileByStore()

			window.dataLayer = window.dataLayer || []
			window.dataLayer.push({
				userID: profile?.customerId,
				userRole: profile?.roleName,
			})
		}
	}

	ngOnInit(): void {
		// commentato per evitare il doppio log
		// this.getProfileChoosenChange();
		const profile = this.profileManagementService.getProfileByStore()
		if ((window.location.href.includes('maintenance-appointments/service-centers') && !!!profile) || ((window.location.href.includes('support/webform') && !!!profile))) {
			this.storageService.setSessionStorage('offline', true)
		} else {
			this.storageService.setSessionStorage('offline', false)
			this.startLoginAndLoadRoute()

			if (!environment.mobile) {
				this.requestNotificationPermission()
			} else {
				// Check offline
				document.addEventListener('online', this.goToHome)
				document.addEventListener('offline', this.goToOfflinePage)
			}

			this.checkIfLogged()
		}
	}

	private goToHome(): void {
		this.router.navigate(['home'])
	}

	private goToOfflinePage(): void {
		this.router.navigate(['home', 'offline'])
	}

	private rootRoute(route: ActivatedRoute): ActivatedRoute {
		while (route.firstChild) {
			route = route.firstChild
		}
		return route
	}

	getProfileChoosenChange(): void {
		this.profileManagementService.changeProfile.subscribe((changeProfile) => {
			this.setAndCheckProfile(changeProfile)
		})
	}

	startLoginAndLoadRoute(): void {
		this.listenToLoading()

		this.subs.add(
			this.profileChooseService.getProfile().subscribe((res) => {
				if (res) {
					this.loadMenu()
				}
			})
		)

		if (this.authService.isLogIn()) {
			this.authService.loadConfiguration(this.getAsscodeFromQueryParam())
		} else {
			this.authService.configureAndRefresh(this.getAsscodeFromQueryParam())
		}

		this.subs.add(
			this.authService.isLogged().subscribe((isLogged) => {
				if (isLogged) {
					this.loadUserInfo()
				}
			})
		)
	}

	loginEmitter(loginProcess): void {
		if (loginProcess) {
			this.startLoginAndLoadRoute()
		}
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe()
		document.removeEventListener('online', this.goToHome)
		document.removeEventListener('offline', this.goToOfflinePage)
	}

	getAsscodeFromQueryParam(): string {
		const queryString = window.location.search
		const urlParams = new URLSearchParams(queryString)
		const associationCode = urlParams.get('associationCode')
		return associationCode
	}

	listenToLoading(): void {
		this._loading.loadingSub
			.pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
			.subscribe((loading) => {
				this.loading = loading
			})
	}

	isLogged(): boolean {
		return this.authService.isLogIn()
	}

	checkIfLogged(): any {
		setTimeout(() => {
			this.authService.isLogged().subscribe((_) => {
				if (!this.isLogged() && !!this.isMobile) {
					this.subs.add(this.dialog.onOpenDialogResponsive(this.isMobile, WelcomeComponent, {}).subscribe((_) => _))
				}
			})
		}, 1000)
	}

	loadUserInfo(): void {
		if (this.isProfileChosen()) {
			if (this.hasAssociation()) {
				this.setAssociation()
			} else {
				this.checkIfUserIsCustomerService()
			}
		} else {
			this.loadMenu()
		}
	}

checkIfUserIsCustomerService() {
    const rawToken = this.authService.getTokenId(); 

    if (!rawToken) {
        console.warn("Token non ancora presente, riprovo tra 500ms o aspetto l'evento di login...");
        // Se il token non c'è, è inutile procedere. 
        // Dovresti chiamare questo metodo solo DOPO che tryLogin ha risolto la promise.
        return;
    }

    const token = this.getDecodedAccessToken(rawToken);
    
    this.profileManagementService.getCustomerServiceRole().subscribe((customerServiceRoles) => {
        const customerKey = !!token?.roles ? token?.roles[0] : null;
        const isPresent = customerServiceRoles.some((csKey) => csKey === customerKey);

        console.log('isPresent:', isPresent);

        return isPresent
            ? this.csManagementService.setCustomerService(this.isMobile)
            : this.profileManagementService.setProfile(this.isMobile);
    });
}

	// checkIfUserIsCustomerServiceBoolean(): Observable<boolean> {
	// 	const token = this.getDecodedAccessToken(localStorage.getItem('id_token'));
	  
	// 	return this.profileManagementService.getCustomerServiceRole().pipe(
	// 	  map((customerServiceRoles) => {
	// 		const customerKey = !!token?.roles ? token?.roles[0] : null;
	// 		return customerServiceRoles.some((csKey) => csKey === customerKey);
	// 	  })
	// 	);
	// }

	// setAssociation(): void {
	// 	const asscode = this.profileManagementService.getAsscode()
	// 	this.userService
	// 		.setAssociation(asscode)
	// 		.pipe(filter((res) => !!res))
	// 		.subscribe((_) => {
	// 			this.successAssociatedPopUp()
	// 			this.profileManagementService.setProfile(this.isMobile)
	// 		})
	// }

	setAssociation(): void {
		const asscode = this.profileManagementService.getAsscode()
		this.userService
			.setAssociation(asscode)
			.pipe(filter((res) => !!res))
			.subscribe((res: any) => {
				if (res.result) {
					this.successAssociatedPopUp()
					this.profileManagementService.setProfile(this.isMobile)
				} else {
					this.snack.openSnackReferClassWithoutTranslate(res.message, SNACKBAR_CLASS.ERROR_CLASS)
				}
			})
	}

	successAssociatedPopUp(): void {
		this.snack.openSnackReferClassWithTranslationEmbedded('associate_success', SNACKBAR_CLASS.SUCCESS_CLASS)
	}

	hasAssociation(): boolean {
		const assCode = this.profileManagementService.getAsscode()
		return assCode !== null && assCode !== undefined && assCode !== ''
	}

	isProfileChosen(): boolean {
		// TODO gestire asscode
		const profile = this.profileManagementService.getProfileByStore()
		return !profile
	}

	setAndCheckProfile(profileSelected): void {
		this.profileManagementService.checkIfRegisteredAndStoreProfileSelected(profileSelected)
	}

	verifyDelegationForRenderPage(profileSelected: Profile): void {
		if (
			!profileSelected.statoDelega &&
			profileSelected.delegaArt94LastUpdate === '' &&
			!!!profileSelected.isSales &&
			(profileSelected.role == '2' || profileSelected.role == '10')
		) {
			this.router.navigate(['/tools-service/delegation-ald-art94'])
		}
	}

	
	loadMenu(): void {
		var profile = this.profileManagementService.getProfileByStore()
		this.checkCodiceCapoGruppo()
		setTimeout(() => {
			this.subs.add(
				this.sharedService.getMenu().subscribe((resp) => {
					this.sideNavItems = resp?.menu
					
					this.sideNavItems.forEach((element) => {
						/*if (element.cod === "tools_and_services" && element.child) {
							element.child = element.child.filter(child => child.cod !== "claims_report");
						  }*/
						element = this.ifDriverAdd(element)
					})
					this.checkIfIsEnelGroup()
					
					this.profileManagementService.setMenu(this.sideNavItems)
				})
			)
		}, 2000);
		if(profile.role === '1' && profile.lc === 400106) {

			this.supportService.getCodCostCenter(profile.plate).subscribe((resp: any) => {
				profile.codCostCenter = resp.codCostCenter;
				this.profileManagementService.setProfileWebForm(profile)
				console.log('codCostCenter', profile.codCostCenter);
			})
		}
	}

	checkIfIsEnelGroup() {
		this.userService.hasManutenzione().subscribe((hasManutenzioni) => {
			const profile = this.profileManagementService.getProfileByStore()
			profile.isEnel = hasManutenzioni
			this.profileManagementService.setProfileInStore(profile)
		})
	}

	checkCodiceCapoGruppo() {
		const profile = this.profileManagementService.getProfileByStore()
		const customerId = profile.customerId
		this.userService.retrieveCodiceCapoGruppo(customerId).subscribe((resp: any) => {
			profile.codiceCapoGruppo = resp.codiceCapogruppoResponseItem[0].capoGruppoId !== null && resp.codiceCapogruppoResponseItem[0].capoGruppoId !== '' ? resp.codiceCapogruppoResponseItem[0].capoGruppoId : customerId
			this.profileManagementService.setProfileInStore(profile)
			this.checkExclusionFunctionality()
		})
	}

	checkExclusionFunctionality() {
		const profile = this.profileManagementService.getProfileByStore()
		this.userService.exclusionFunctionality(profile.codiceCapoGruppo).subscribe((resp: any) => {
			profile.exclusionFunctionality = resp.content
			this.profileManagementService.setProfileInStore(profile)
		})
	}

	manageMenuFromCodiceCapoGruppoOrCaptive(profile, menuEl) {
		if(profile.exclusionFunctionality.includes('408453')) {
			// if(menuEl.cod === 'maintenance_and_appointments') {
			// 	menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'tyres')
			// }
			if(menuEl.cod === 'contracts') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'modify_contracts')
			}
		}

		if(profile.role === '1' && profile.exclusionFunctionality.includes('409341')) {
			if(menuEl.cod === 'support') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_requests_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'manage_requests_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'manage_bookings_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_claims_webform')
			}
		}

		if(
			this.apiSearchUtilService.findTerm(this.basePath, 'smart') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'ford') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'honda') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'suzuki') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'landrover') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'jaguar') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'lynkco') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'omodajaecoo') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'mg') ||
			this.apiSearchUtilService.findTerm(this.basePath, 'fordfleetmanagement')
		) {
			if(menuEl.cod === 'contracts') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'modify_contracts')
			}

			if(menuEl.cod === 'support') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_requests_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'manage_requests_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'manage_bookings_webform')
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_claims_webform')
			}
		}
		return menuEl;
	}


	ifDriverAdd(menuEl): any {
		const profile = this.profileManagementService.getProfileByStore()
		menuEl = this.manageQuotatorMenuIfNotEnabled(menuEl, profile)
		menuEl = this.manageCarsharingIfNotEnabled(menuEl, profile)
		menuEl = profile.lc === 400106 ? this.manageMenuStartingFromRoleDriverPoste(profile, menuEl) : this.manageMenuStartingFromRole(profile, menuEl)
		if(profile.lc === 400106) {
			menuEl = this.manageMenuStartingFromRoleFMPoste(profile, menuEl)
		}
		menuEl = this.removeVehicleListStartingFromDriverRole(menuEl, profile)
		//menuEl = this.manageMenuFromCustomerService(menuEl)
		menuEl = this.removeAppointmentsStartingFromDriverRole(menuEl, profile)
		//menuEl = this.removeAppointmentsAndClaimsTemporary(menuEl)
		menuEl = this.manageMenuDriverStartingFromRole(profile, menuEl)
		menuEl= this.removeCarSharingFromNoPoste(menuEl,profile);

		menuEl = this.manageMenuFromCodiceCapoGruppoOrCaptive(profile, menuEl)
		menuEl = this.manageCustomerInvoicesListExLeasePlan(menuEl, profile);
		//menuEl = this.manageMenuStartingFromCaptive(profile, menuEl)
		//menuEl = this.removeTiresMovementsFromMenu(menuEl, profile) //PROVVISORIO

	}

	// manageMenuFromCustomerService(menuEl) {
	// 	this.checkIfUserIsCustomerServiceBoolean().subscribe((isCustomerService) => {
	// 	  if (isCustomerService) {
	// 		console.log('isCustomerService', isCustomerService)
	// 		if (menuEl.cod === 'management') {
	// 		  menuEl.child = this.apiSearchUtilService.addDynamicObjPostRestCall('management_list');
	// 		}
	// 	  }
	// 	});
	// }


	manageMenuDriverStartingFromRole(profile, menuEl): any {
		if (!!profile && profile.role == '1' || profile.role == '5') {
			if (menuEl?.cod === 'contracts') {
				menuEl.child.unshift(this.apiSearchUtilService.addDynamicObjPostRestCall('contracts', profile))
			}
		}
		return menuEl
	}

	manageMenuStartingFromRole(profile, menuEl): any {
		if (!!profile && (profile.role == '1' || profile.role == '5' || profile.role == '8')) {
			if (menuEl.cod === 'vehicles') {
				menuEl.child.unshift(this.apiSearchUtilService.addDynamicObjPostRestCall('vehicles', profile))
			}
			if (menuEl.cod === 'tools_and_services') {
				menuEl.child.push(this.apiSearchUtilService.addDynamicObjPostRestCall('tools_and_services', profile))
			}
			if (menuEl.cod === 'maintenance_and_appointments') {
				menuEl.child.push(this.apiSearchUtilService.addDynamicObjPostRestCall('maintenance_and_appointments', profile))
			}
		}
		return menuEl
	}
	manageMenuStartingFromRoleDriverPoste(profile, menuEl): any {
		if (!!profile && (profile.role == '1' || profile.role == '5' || profile.role == '8')) {
			if (menuEl.cod === 'vehicles') {
				menuEl.child.unshift(this.apiSearchUtilService.addDynamicObjPostRestCall('vehicles', profile))
			}
			if (menuEl.cod === 'tools_and_services') {
				menuEl.child.push(this.apiSearchUtilService.addDynamicObjPostRestCall('tools_and_services', profile))
			}
			if (menuEl.cod === 'maintenance_and_appointments') {
				menuEl.child.push(this.apiSearchUtilService.addDynamicObjPostRestCallPoste('maintenance_and_appointments', profile))
			}

			if (menuEl.cod === 'support') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_claims_webform')
			}
		}
		return menuEl
	}

	manageMenuStartingFromRoleFMPoste(profile, menuEl): any {
		if (!!profile && profile.role === '2') {
			if (menuEl.cod === 'maintenance_and_appointments') {
				const maintenanceChild = menuEl.child.find(child => child.cod === 'maintenance');
				if (maintenanceChild) {
					maintenanceChild.label = 'Monitoraggio manutenzioni';
				}
			}

			if (menuEl.cod === 'support') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'create_new_claims_webform')
			}
		}
		return menuEl
	}

	removeVehicleListStartingFromDriverRole(menuEl, profile) {
		if (!!profile && profile.role == '1') {
			if (menuEl.cod === 'vehicles') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'vehicles_list')
			}
		}
		if (!!profile && (profile.role == '7' || profile.role == '5')) { //AGGIUNTO RUOLO 5 DRIVER RICARICAR PER OSCURAMENTO RICARICAR
			if (menuEl.cod === 'vehicles') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'ricaricar')
			}
		}
		return menuEl
	}

	// removeTiresMovementsFromMenu(menuEl, profile) { //PROVVISORIO
	// 	if (!!profile && profile.role == '2' || profile.role == '7' || profile.role == '1' || profile.role == '5') {
	// 	  if (menuEl.cod === 'maintenance_and_appointments' && menuEl.child) {
	// 		const tyresMenu = menuEl.child.find(item => item.cod === 'tyres');
	// 		if (tyresMenu && tyresMenu.child) {
	// 		  tyresMenu.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(tyresMenu.child, 'movements_list');
	// 		}
	// 	  }
	// 	}
	// 	return menuEl;
	//   }

	removeAppointmentsStartingFromDriverRole(menuEl, profile) {
		if (
			!!profile &&
			(profile.role == '1' || profile.role == '5') &&
			profile.customerId !== '107265' &&
			profile.customerId !== '40134519' &&
			profile.customerId !== '40492519' &&
			profile.customerId !== '40429302' &&
			profile.customerId !== '40498935' &&
			profile.customerId !== '40526939' &&
			profile.customerId !== '40498995' &&
			profile.customerId !== '40567646' &&
			profile.customerId !== '40037082' &&
			profile.customerId !== '41979885' &&
			profile.customerId !== '41979921' &&
			profile.customerId !== '41979904' &&
			profile.customerId !== '41457391' 
		) {
			if (menuEl.cod === 'tools_and_services') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'ticket_post_94')
			}
		}
		return menuEl
	}

	removeCarSharingFromNoPoste(menuEl, profile) {
		if (profile.lc!=400106 ) {
			if (menuEl.cod === 'tools_and_services') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'car_sharing_pt')
			}
		}
		return menuEl
	}


	manageCarsharingIfNotEnabled(menuEl, profile) {
		if (!profile.isCarSharing) {
			if (menuEl.cod === 'car_sharing') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(this.sideNavItems, 'car_sharing')
			}
		}
		return menuEl
	}

	manageQuotatorMenuIfNotEnabled(menuEl, profile): any {
		if (!profile.isCorporateQuoterEnabled) {
			if (menuEl.cod === 'administration') {
				menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'quotator')
			}
		}
		return menuEl
	}

	onOpenedChange(isOpen): void {
		this.isSidenavOpen = isOpen
	}

	requestNotificationPermission(): void {
		const m = this.injector.get(AngularFireMessaging)
		m.requestPermission.pipe(mergeMapTo(m.tokenChanges)).subscribe(
			(token) => {
				const oldToken = localStorage.getItem('fcm_token')

				if (token && oldToken != token) {
					localStorage.setItem('fcm_token', token)
					localStorage.removeItem('fcm_token_sent')
				}
			},
			(err) => {
				console.log('requestPermission error.', err)
			}
		)
	}

	// listen() {
	//   const messaging = getMessaging();
	//   onMessage(messaging, (payload) => {
	//    console.log('Message received. ', payload);
	//  });
	// }

	removeAppointmentsAndClaimsTemporary(menuEl) {
		if(menuEl.cod === 'maintenance_and_appointments') {
			menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'appointments')
		}
		if(menuEl.cod === 'tools_and_services') {
			menuEl.child = this.apiSearchUtilService.removeElementFromArrayStartingFromCod(menuEl.child, 'claims_report')
		}

		return menuEl
	}

	manageCustomerInvoicesListExLeasePlan(menuEl, profile) {
		if((profile.role !== '2') || (profile.lc !== 400104 && profile.lc !== 400106 && profile.lc !== 400105 && profile.lc !== 400107)) {
			if(menuEl.cod === 'administration') {
				const index = menuEl.child.findIndex(child => child.cod === 'customer_invoices_list');

				if(index !== -1) {
					const childIndexToRemove = menuEl.child[index].child.findIndex(child => child.cod === 'customer_invoices_list_olsa');

					if(childIndexToRemove !== -1) {
						menuEl.child[index].child.splice(childIndexToRemove, 1);
					}
				}
			}
		}

		return menuEl
	}
} 
